"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionConfig = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("../FormQuestionController/FormQuestionControllerRegistry"));
function getQuestionConfig(type, q) {
    var _a, _b;
    if ((_a = q.config) === null || _a === void 0 ? void 0 : _a[type])
        return (_b = q.config) === null || _b === void 0 ? void 0 : _b[type];
    return FormQuestionControllerRegistry_1.default[type].createConfig();
}
exports.getQuestionConfig = getQuestionConfig;
exports.default = getQuestionConfig;
